<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-6 mb-20">
                        <h6 class=" float-left mb-0 ml-10 fs-18 fw-700" style="color: #000">FEATURES</h6>
                    </div>
                   
                </div>
                <div class="col-md-12 mb-20 text-start" style="color: black;">
                    <p><b>The Global Pay Multi-Currency Card</b> is thoughtfully designed to make your travel hassle-free by replacing the need for multiple forex cards.</p>
                    <p>Accepted at over <b>100 million VISA merchant outlets</b> worldwide, this prepaid multicurrency card is app-enabled and supports <b>30 international currencies: USD, GBP, EUR, CHF, CAD, AUD, SGD, HKD, THB, AED, SAR, ZAR, NZD, SEK, NOK, JPY, DKK, MYR, IDR, TRY, QAR, VND, CNY, KWD, OMR, KRW, PHP, GRL, AZN, and ILS.</b></p>
                    
                </div>

                
               
              <div class="benefit">
                <div class="row mt-6">  
                    <div class="col-6 col-sm-4 col-md-3 mb-3" *ngFor="let singleItem of menuItems"> 
                        <div class="d-flex align-items-center feature-section">
                            <img src="assets/images/global-pay-multi-features/{{singleItem.icon}}" style="width: 60px; height: 60px;">
                            <div class="fs-14 fw-600" >
                                {{ singleItem.title }}
                            </div>
                        </div>
                    </div>
                </div>
            
                    <!-- <div class="row">
                        <div class="col-md-6 mb-20">
                            <h6 class=" float-left mb-0 ml-10 fs-18 fw-700" style="color: #000">BENEFITS</h6>
                        </div> 
                    </div>
                    <div class="row mt-6">  
                        <div class="col-6 col-sm-4 col-md-3 mb-3" *ngFor="let singleItem of Items"> 
                            <div class="d-flex align-items-center feature-section benefits" (click)="goToFeatures(singleItem)">
                                <img src="assets/images/benefits/{{singleItem.icon}}" style="width: 60px; height: 60px;">
                                <div class="fs-14 fw-600">
                                    {{ singleItem.title }}
                                </div>
                            </div>
                        </div>
                    </div> -->
                </div>
                    <div class="col-md-6 text-left ">
                        <button  class="btn btn-benefit" (click)="goToBackPage()">
                            Back
                        </button>
                        </div>
            </div>
        </div>
    </div>
</div>